const l = {
  name: "Help",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,0C9,0,0,9,0,20s9,20,20,20c11,0,20-9,20-20S31,0,20,0z M10.6,4.7C13.3,3,16.5,2,20,2s6.7,1,9.4,2.7l-6,6
			C22.4,10.2,21.2,10,20,10c-1.2,0-2.4,0.2-3.5,0.6L10.6,4.7z M25.4,11.6l5.7-5.7c1.1,0.9,2.2,1.9,3.1,3.1l-5.7,5.7
			C27.7,13.4,26.6,12.3,25.4,11.6z M35.3,10.6c1.7,2.7,2.7,6,2.7,9.4s-1,6.7-2.7,9.4l-6-6c0.4-1.1,0.6-2.2,0.6-3.5
			c0-1.2-0.2-2.4-0.6-3.5L35.3,10.6z M8.9,5.8l5.7,5.7c-1.2,0.8-2.3,1.8-3.1,3.1L5.8,8.9C6.7,7.8,7.8,6.7,8.9,5.8z M10.6,16.5
			C10.2,17.6,10,18.8,10,20c0,1.2,0.2,2.4,0.6,3.5l-6,6C3,26.7,2,23.5,2,20s1-6.7,2.7-9.4L10.6,16.5z M8.9,34.2
			c-1.1-0.9-2.2-1.9-3.1-3.1l5.7-5.7c0.8,1.2,1.8,2.3,3.1,3.1L8.9,34.2z M10.6,35.3l6-6c1.1,0.4,2.2,0.6,3.5,0.6
			c1.2,0,2.4-0.2,3.5-0.6l6,6C26.7,37,23.5,38,20,38S13.3,37,10.6,35.3z M28.4,25.4l5.7,5.7c-0.9,1.1-1.9,2.2-3.1,3.1l-5.7-5.7
			C26.6,27.7,27.7,26.6,28.4,25.4z M12,20c0-4.4,3.6-8,8-8s8,3.6,8,8s-3.6,8-8,8S12,24.4,12,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as Help
};
